import Row from '$tablet-app/src/app/components/Row';
import Spacer from '$tablet-app/src/app/components/Spacer';
import Text from '$tablet-app/src/app/components/Text';
import { palette } from '$tablet-app/src/app/theme';
import { Button } from '@akin-home/buttons/native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import styled from 'styled-components/native';
import { useMealPreferenceDialogState } from '../../store/useMealPreferenceDialogState';

const PeoplePreferencesView = () => {
  const people =
    useMealPreferenceDialogState((state) => state.draft_preferences.people) ||
    1;

  const update = useMealPreferenceDialogState(
    (state) => state.updatePreference
  );

  const onPressIncrement = () => update({ people: people + 1 });

  const onPressDecrement = () =>
    update({ people: people === 1 ? 1 : people - 1 });

  return (
    <Container>
      <Row alignItems="center">
        <IconContainer>
          <FontAwesomeIcon
            icon="user-friends"
            color={palette.yellow_700}
            size={30}
          />
        </IconContainer>

        <Spacer width="16px" />

        <Text weight="semibold">People</Text>
      </Row>

      <Row alignItems="center">
        <Button
          variant="secondary"
          icon="minus"
          size="large"
          onPress={onPressDecrement}
        />

        <PeopleText weight="semibold">{people}</PeopleText>

        <Button
          variant="secondary"
          icon="plus"
          size="large"
          onPress={onPressIncrement}
        />
      </Row>
    </Container>
  );
};

const Container = styled.View`
  flex-direction: row;
  justify-content: space-between;

  align-items: center;

  padding: 32px;
`;

const IconContainer = styled.View`
  width: 62px;
  height: 62px;

  justify-content: center;
  align-items: center;

  background-color: ${palette.yellow_200}
  border-radius: 22px;
`;

const PeopleText = styled(Text)`
  text-align: center;

  width: 60px;
`;

export default PeoplePreferencesView;
